<div class="cr-add-block-backdrop" (click)="closeModal.emit()"></div>

<div class="cr-add-block-modal">
  <div class="cr-add-block-modal-head">
    <span class="cr-add-block-modal-title">Add new block</span>
    <button type="button" class="cr-icon-btn" (click)="closeModal.emit()" title="Close">
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
        <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="cr-add-block-modal-list">
    <div
      class="cr-add-block-row"
      *ngFor="let block of blockSelect"
      (mouseenter)="setHovered(block, $event)"
      (mouseleave)="setHovered(null)"
    >
      <span class="cr-add-block-name">{{ block.dropdownName }}</span>

      <div class="cr-add-block-row-actions">
        <button
          type="button"
          class="cr-add-block-icon-btn"
          (click)="openPreview(block)"
          title="Preview block"
        >
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
            <rect x="3" y="3" width="6" height="6" rx="1.2" stroke="currentColor" stroke-width="1.4"/>
            <rect x="11" y="11" width="6" height="6" rx="1.2" stroke="currentColor" stroke-width="1.4"/>
          </svg>
        </button>
        <button
          type="button"
          class="cr-add-block-icon-btn cr-add-block-icon-btn-primary"
          (click)="selectBlock(block)"
          title="Add block"
        >+</button>
      </div>
    </div>
  </div>

  <!-- Rendered once, outside the scrolling row list (not per-row): the list
       needs overflow-y:auto to scroll, but a "visible" X axis on the same
       element gets forced back to auto by the browser whenever the other
       axis isn't visible (see the CSS overflow spec's paired-axis rule), so
       a popover nested inside the list can never escape it horizontally.
       Positioned via a plain top offset captured on hover instead. -->
  <div class="cr-block-preview-popover" *ngIf="hoveredBlock as block" [style.top.px]="hoveredRowOffsetTop">
    <div class="cr-block-preview-copy">
      <div class="cr-block-preview-label">Block Preview</div>
      <div class="cr-block-preview-name">{{ block.dropdownName }}</div>
      <p class="cr-block-preview-desc">{{ previewDescription(block) }}</p>
    </div>
    <div class="cr-block-preview-thumb" [ngSwitch]="block.name">
      <div class="cr-hover-diagram cr-hover-hero" *ngSwitchCase="'main-banner'">
        <span class="cr-hover-image cr-hover-image-hero"><i></i></span>
      </div>
      <div class="cr-hover-diagram" *ngSwitchCase="'paragraph-cta'">
        <span class="cr-hover-lines">
          <i></i>
          <i></i>
          <i></i>
        </span>
        <span class="cr-hover-button"></span>
      </div>
      <div class="cr-hover-diagram" *ngSwitchCase="'heading'">
        <span class="cr-hover-lines cr-hover-headline">
          <i></i>
          <i></i>
          <i></i>
        </span>
        <!-- Invisible - .cr-hover-diagram needs a 2nd grid item to size/center
             correctly (a single-item grid collapsed the lines entirely); this
             block has no CTA in reality, so no visible button belongs here. -->
        <span class="cr-hover-button cr-hover-button-hidden"></span>
      </div>
      <div class="cr-hover-diagram" *ngSwitchCase="'only-intro'">
        <span class="cr-hover-lines">
          <i></i>
          <i></i>
          <i></i>
        </span>
        <span class="cr-hover-button cr-hover-button-hidden"></span>
      </div>
      <div class="cr-hover-diagram" *ngSwitchCase="'only-cta'">
        <span class="cr-hover-button cr-hover-button-standalone"></span>
      </div>
      <div class="cr-hover-diagram" *ngSwitchCase="'disclaimer'">
        <span class="cr-hover-lines cr-hover-small">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </span>
        <span class="cr-hover-button cr-hover-button-hidden"></span>
      </div>
      <div class="cr-hover-diagram cr-hover-stacked" *ngSwitchCase="'property-description'">
        <span class="cr-hover-image"><i></i></span>
        <span class="cr-hover-lines cr-hover-stacked-lines">
          <i></i>
          <i></i>
        </span>
        <span class="cr-hover-button"></span>
      </div>
      <div class="cr-hover-diagram cr-hover-counter" *ngSwitchCase="'counter'">
        <span class="cr-hover-counter-digits">
          <b>0</b><b>2</b><i>:</i><b>1</b><b>5</b>
        </span>
        <small>DAYS&nbsp;&nbsp;&nbsp;HOURS</small>
      </div>
      <div class="cr-hover-diagram cr-hover-stacked" *ngSwitchCase="'event'">
        <span class="cr-hover-image"><i></i></span>
        <span class="cr-hover-lines cr-hover-stacked-lines">
          <i></i>
          <i></i>
        </span>
        <span class="cr-hover-button"></span>
      </div>
      <div class="cr-hover-diagram cr-hover-stacked" *ngSwitchCase="'property-usp-1x-photo'">
        <span class="cr-hover-image"><i></i></span>
        <span class="cr-hover-lines cr-hover-stacked-lines">
          <i></i>
          <i></i>
          <i></i>
        </span>
        <span class="cr-hover-button"></span>
      </div>
      <div class="cr-hover-two-cards" *ngSwitchCase="'property-usp-2x-photo'">
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <div class="cr-hover-with-heading" *ngSwitchCase="'x2-experiences'">
        <span class="cr-hover-heading-line"></span>
        <span class="cr-hover-two-cards">
          <span class="cr-hover-two-card">
            <span class="cr-hover-image"><i></i></span>
            <span class="cr-hover-lines"><i></i><i></i></span>
            <span class="cr-hover-button"></span>
          </span>
          <span class="cr-hover-two-card">
            <span class="cr-hover-image"><i></i></span>
            <span class="cr-hover-lines"><i></i><i></i></span>
            <span class="cr-hover-button"></span>
          </span>
        </span>
      </div>
      <div class="cr-hover-two-cards" *ngSwitchCase="'inspiration'">
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <div class="cr-hover-three-cards" *ngSwitchCase="'x3-experiences'">
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <div class="cr-hover-two-cards" *ngSwitchCase="'only-2-photos'">
        <span class="cr-hover-two-card">
          <span class="cr-hover-image cr-hover-image-tall"><i></i></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image cr-hover-image-tall"><i></i></span>
        </span>
      </div>
      <div class="cr-hover-zigzag" *ngSwitchCase="'zigzag-heading-and-cta'">
        <span class="cr-hover-zigzag-row">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-zigzag-copy">
            <span class="cr-hover-lines"><i></i><i></i></span>
            <span class="cr-hover-button"></span>
          </span>
        </span>
        <span class="cr-hover-zigzag-row cr-hover-zigzag-reverse">
          <span class="cr-hover-zigzag-copy">
            <span class="cr-hover-lines"><i></i><i></i></span>
          </span>
          <span class="cr-hover-image"><i></i></span>
        </span>
      </div>
      <div class="cr-hover-zigzag" *ngSwitchCase="'zigzag-no-heading-no-button'">
        <span class="cr-hover-zigzag-row">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-zigzag-copy">
            <span class="cr-hover-lines"><i></i><i></i></span>
          </span>
        </span>
        <span class="cr-hover-zigzag-row cr-hover-zigzag-reverse">
          <span class="cr-hover-zigzag-copy">
            <span class="cr-hover-lines"><i></i><i></i></span>
          </span>
          <span class="cr-hover-image"><i></i></span>
        </span>
      </div>
      <div class="cr-hover-zigzag" *ngSwitchCase="'zigzag-heading-and-alt-cta'">
        <span class="cr-hover-zigzag-row">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-zigzag-copy">
            <span class="cr-hover-lines"><i></i><i></i></span>
            <span class="cr-hover-button cr-hover-button-secondary"></span>
          </span>
        </span>
        <span class="cr-hover-zigzag-row cr-hover-zigzag-reverse">
          <span class="cr-hover-zigzag-copy">
            <span class="cr-hover-lines"><i></i><i></i></span>
          </span>
          <span class="cr-hover-image"><i></i></span>
        </span>
      </div>
      <div class="cr-hover-diagram cr-hover-reviews" *ngSwitchCase="'reviews'">
        <strong class="cr-hover-stars">★★★★★</strong>
        <span class="cr-hover-lines"><i></i><i></i><i></i></span>
      </div>
      <div class="cr-hover-icon-copy" *ngSwitchCase="'voucher'">
        <span class="cr-hover-gift-icon">
          <svg viewBox="0 0 48 48" width="27" height="27" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 20h28v20H10zM8 15h32v8H8zM24 15v25M15 15c-4-7 7-9 9 0M33 15c4-7-7-9-9 0" />
          </svg>
        </span>
        <span class="cr-hover-lines"><i></i><i></i><i></i></span>
      </div>
      <div class="cr-hover-icon-copy" *ngSwitchCase="'gift-voucher'">
        <span class="cr-hover-gift-icon">
          <svg viewBox="0 0 48 48" width="27" height="27" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 20h28v20H10zM8 15h32v8H8zM24 15v25M15 15c-4-7 7-9 9 0M33 15c4-7-7-9-9 0" />
          </svg>
        </span>
        <span class="cr-hover-icon-copy-lines">
          <span class="cr-hover-lines"><i></i><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <div class="cr-hover-icon-copy" *ngSwitchCase="'experience-concierge'">
        <span class="cr-hover-gift-icon">
          <svg viewBox="0 0 48 48" width="27" height="27" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 20h28v20H10zM8 15h32v8H8zM24 15v25M15 15c-4-7 7-9 9 0M33 15c4-7-7-9-9 0" />
          </svg>
        </span>
        <span class="cr-hover-lines"><i></i><i></i><i></i></span>
      </div>
      <div class="cr-hover-diagram cr-hover-hero" *ngSwitchCase="'moments'">
        <span class="cr-hover-image cr-hover-image-hero"><i></i></span>
      </div>
      <div class="cr-hover-diagram cr-hover-contact" *ngSwitchCase="'reservation'">
        <span class="cr-hover-contact-images">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-image"><i></i></span>
        </span>
        <span class="cr-hover-lines cr-hover-contact-lines">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>
      <div class="cr-hover-icon-copy" *ngSwitchCase="'check-in'">
        <span class="cr-hover-image cr-hover-round-image"><i></i></span>
        <span class="cr-hover-icon-copy-lines">
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <div class="cr-hover-icon-copy" *ngSwitchCase="'valamar-app'">
        <span class="cr-hover-image cr-hover-app-icon"><i></i></span>
        <span class="cr-hover-icon-copy-lines">
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-app-buttons">
            <span class="cr-hover-button"></span>
            <span class="cr-hover-button"></span>
          </span>
        </span>
      </div>
      <div class="cr-hover-two-cards" *ngSwitchCase="'x2-prop-rec-onp'">
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-price-tags"><em>OLD</em><b>NEW</b></span>
          <span class="cr-hover-button"></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-price-tags"><em>OLD</em><b>NEW</b></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <div class="cr-hover-two-cards" *ngSwitchCase="'x2-prop-rec'">
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
        <span class="cr-hover-two-card">
          <span class="cr-hover-image"><i></i></span>
          <span class="cr-hover-lines"><i></i><i></i></span>
          <span class="cr-hover-button"></span>
        </span>
      </div>
      <svg *ngSwitchDefault viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
        <rect width="100" height="75" rx="6" fill="var(--cr-primary-soft)"/>
        <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
        <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
      </svg>
    </div>
  </div>
</div>

<!-- Large click-to-preview modal - sibling overlay, own backdrop, sits above
     the catalog list. Only opens for blocks with a finished preview so far
     (see hasRealPreview()). -->
<ng-container *ngIf="previewedBlock as block">
  <div class="cr-block-preview-modal-backdrop" (click)="closePreview()"></div>
  <div class="cr-block-preview-modal">
    <div class="cr-block-preview-modal-head">
      <div>
        <div class="cr-block-preview-label">Block Preview</div>
        <div class="cr-block-preview-modal-name">{{ block.dropdownName }}</div>
        <p class="cr-block-preview-modal-desc">{{ previewDescription(block) }}</p>
      </div>
      <button type="button" class="cr-icon-btn" (click)="closePreview()" title="Close">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
          <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="cr-block-preview-modal-tabs">
      <button
        type="button"
        class="cr-block-preview-modal-tab"
        [class.active]="previewDeviceMode === 'desktop'"
        (click)="setPreviewDevice('desktop')"
      >
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
          <rect x="2.5" y="3.5" width="15" height="10" rx="1.2" stroke="currentColor" stroke-width="1.4"/>
          <path d="M7.5 17h5M10 13.5V17" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
        Desktop
      </button>
      <button
        type="button"
        class="cr-block-preview-modal-tab"
        [class.active]="previewDeviceMode === 'mobile'"
        (click)="setPreviewDevice('mobile')"
      >
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
          <rect x="5.5" y="2.5" width="9" height="15" rx="1.4" stroke="currentColor" stroke-width="1.4"/>
          <path d="M9 15.2h2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        </svg>
        Mobile
      </button>
    </div>

    <div class="cr-block-preview-modal-body">
      <div
        class="cr-block-preview-canvas"
        [class.mobile]="previewDeviceMode === 'mobile'"
        [class.cr-auto-height]="
          block.name === 'property-description' ||
          block.name === 'event' ||
          block.name === 'x2-prop-rec' ||
          block.name === 'property-usp-1x-photo' ||
          block.name === 'property-usp-2x-photo' ||
          block.name === 'x2-experiences' ||
          block.name === 'inspiration' ||
          block.name === 'x3-experiences' ||
          block.name === 'only-2-photos' ||
          block.name === 'voucher' ||
          block.name === 'gift-voucher' ||
          block.name === 'experience-concierge' ||
          block.name === 'reservation' ||
          block.name === 'check-in' ||
          block.name === 'valamar-app' ||
          block.name === 'x2-prop-rec-onp' ||
          block.name === 'reviews' ||
          block.name === 'zigzag-heading-and-cta' ||
          block.name === 'zigzag-heading-and-alt-cta' ||
          block.name === 'zigzag-no-heading-no-button'
        "
        [ngSwitch]="block.name"
      >
        <div class="cr-full-image-preview" *ngSwitchCase="'main-banner'">
          <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
            <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
            <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
            <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
          </svg>
        </div>
        <div class="cr-pc-preview" *ngSwitchCase="'paragraph-cta'">
          <p class="cr-pc-preview-text">{{ introCtaPreviewText }}</p>
          <span class="cr-pc-preview-cta">{{ introCtaPreviewCtaText }}</span>
        </div>
        <div class="cr-headline-preview" *ngSwitchCase="'heading'">
          <p class="cr-headline-preview-text">{{ headlinePreviewText }}</p>
        </div>
        <div class="cr-oi-preview" *ngSwitchCase="'only-intro'">
          <p class="cr-oi-preview-text">{{ onlyIntroPreviewText }}</p>
        </div>
        <div class="cr-oc-preview" *ngSwitchCase="'only-cta'">
          <span class="cr-oc-preview-cta">{{ onlyCtaPreviewCtaText }}</span>
        </div>
        <div class="cr-dc-preview" *ngSwitchCase="'disclaimer'">
          <p class="cr-dc-preview-text">{{ disclaimerPreviewText }}</p>
        </div>
        <div class="cr-propdesc-preview" *ngSwitchCase="'property-description'">
          <div class="cr-propdesc-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <p class="cr-propdesc-preview-title">{{ propertyDescPreviewTitle }}</p>
          <p class="cr-propdesc-preview-text">{{ propertyDescPreviewText }}</p>
          <span class="cr-propdesc-preview-cta">{{ propertyDescPreviewCtaText }}</span>
        </div>
        <div class="cr-ev-preview" *ngSwitchCase="'event'">
          <div class="cr-ev-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <p class="cr-ev-preview-text">{{ eventPreviewText }}</p>
          <span class="cr-ev-preview-cta">{{ eventPreviewCtaText }}</span>
        </div>
        <div class="cr-counter-preview" *ngSwitchCase="'counter'">
          <span class="cr-counter-preview-digits">
            <b>0</b><b>2</b><i>:</i><b>1</b><b>5</b>
          </span>
          <small>DAYS&nbsp;&nbsp;&nbsp;HOURS</small>
        </div>
        <div class="cr-pu-preview" *ngSwitchCase="'property-usp-1x-photo'">
          <div class="cr-pu-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <p class="cr-pu-preview-title">{{ propertyUspPreviewTitle }}</p>
          <ul class="cr-pu-preview-usp-list">
            <li class="cr-pu-preview-usp-row" *ngFor="let usp of propertyUspPreviewRows">
              <span class="cr-pu-preview-checkmark">&#10003;</span>
              <span>{{ usp }}</span>
            </li>
          </ul>
        </div>
        <div class="cr-pu-preview" *ngSwitchCase="'property-usp-2x-photo'">
          <div class="cr-p2-preview-image-row">
            <div class="cr-pu-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <div class="cr-pu-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
          </div>
          <p class="cr-pu-preview-title">{{ propertyUspPreviewTitle }}</p>
          <ul class="cr-pu-preview-usp-list">
            <li class="cr-pu-preview-usp-row" *ngFor="let usp of propertyUspPreviewRows">
              <span class="cr-pu-preview-checkmark">&#10003;</span>
              <span>{{ usp }}</span>
            </li>
          </ul>
        </div>
        <div class="cr-xe-preview" *ngSwitchCase="'x2-experiences'">
          <p class="cr-xe-preview-paragraph">{{ x2ExperiencesPreviewParagraph }}</p>
          <div class="cr-xe-preview-grid">
            <div class="cr-xe-preview-card" *ngFor="let card of x2ExperiencesPreviewCards">
              <div class="cr-xe-preview-image">
                <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                  <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                  <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                  <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
                </svg>
              </div>
              <p class="cr-xe-preview-heading">{{ card.heading }}</p>
              <p class="cr-xe-preview-desc">{{ card.description }}</p>
              <span class="cr-xe-preview-cta">{{ card.ctaText }}</span>
            </div>
          </div>
        </div>
        <div class="cr-in-preview" *ngSwitchCase="'inspiration'">
          <div class="cr-in-preview-card" *ngFor="let card of inspirationPreviewCards">
            <div class="cr-in-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <p class="cr-in-preview-heading">{{ card.heading }}</p>
            <span class="cr-in-preview-cta">{{ card.ctaText }}</span>
          </div>
        </div>
        <div class="cr-x3-preview" *ngSwitchCase="'x3-experiences'">
          <div class="cr-x3-preview-card" *ngFor="let card of x3ExperiencesPreviewCards">
            <div class="cr-x3-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <p class="cr-x3-preview-heading">{{ card.heading }}</p>
            <span class="cr-x3-preview-cta">{{ card.ctaText }}</span>
          </div>
        </div>
        <div class="cr-o2p-preview" *ngSwitchCase="'only-2-photos'">
          <div class="cr-o2p-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-o2p-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
        </div>
        <div class="cr-vch-preview" *ngSwitchCase="'voucher'">
          <div class="cr-vch-preview-row">
            <div class="cr-vch-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <div class="cr-vch-preview-content">
              <p class="cr-vch-preview-heading">{{ voucherPreviewHeading }}</p>
              <p class="cr-vch-preview-text">{{ voucherPreviewText }}</p>
              <span class="cr-vch-preview-cta">{{ voucherPreviewCtaText }}</span>
            </div>
          </div>
          <p class="cr-vch-preview-paragraph">{{ voucherPreviewParagraph }}</p>
        </div>
        <div class="cr-gv-preview" *ngSwitchCase="'gift-voucher'">
          <div class="cr-gv-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-gv-preview-content">
            <p class="cr-gv-preview-heading">{{ giftVoucherPreviewHeading }}</p>
            <p class="cr-gv-preview-text">{{ giftVoucherPreviewText }}</p>
            <span class="cr-gv-preview-cta">{{ giftVoucherPreviewCtaText }}</span>
          </div>
        </div>
        <div class="cr-cg-preview" *ngSwitchCase="'experience-concierge'">
          <div class="cr-cg-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-cg-preview-content">
            <p class="cr-cg-preview-heading">{{ conciergePreviewHeading }}</p>
            <p class="cr-cg-preview-text">{{ conciergePreviewText }}</p>
          </div>
        </div>
        <div class="cr-full-image-preview" *ngSwitchCase="'moments'">
          <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
            <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
            <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
            <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
          </svg>
        </div>
        <div class="cr-res-preview" *ngSwitchCase="'reservation'">
          <p class="cr-res-preview-heading">Your accommodation</p>
          <div class="cr-res-preview-images">
            <div class="cr-res-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <div class="cr-res-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
          </div>
          <p class="cr-res-preview-name">{{ reservationPreviewName }}</p>
          <div class="cr-res-preview-details">
            <p class="cr-res-preview-line"><b>Address:</b> {{ reservationPreviewAddress }}</p>
            <p class="cr-res-preview-line"><b>Telephone:</b> {{ reservationPreviewTelephone }}</p>
            <div class="cr-res-preview-times">
              <p class="cr-res-preview-line"><b>Check-In:</b> {{ reservationPreviewCheckIn }}</p>
              <p class="cr-res-preview-line"><b>Check-Out:</b> {{ reservationPreviewCheckOut }}</p>
            </div>
          </div>
        </div>
        <div class="cr-ci-preview" *ngSwitchCase="'check-in'">
          <div class="cr-ci-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-ci-preview-content">
            <p class="cr-ci-preview-heading">{{ checkInPreviewHeading }}</p>
            <p class="cr-ci-preview-text">{{ checkInPreviewText }}</p>
            <span class="cr-ci-preview-cta">{{ checkInPreviewCtaText }}</span>
          </div>
        </div>
        <div class="cr-va-preview" *ngSwitchCase="'valamar-app'">
          <div class="cr-va-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-va-preview-content">
            <p class="cr-va-preview-heading">{{ valamarAppPreviewHeading }}</p>
            <p class="cr-va-preview-text">{{ valamarAppPreviewText }}</p>
            <div class="cr-va-preview-store-row">
              <span class="cr-va-preview-store-link">Google Play</span>
              <span class="cr-va-preview-store-link">App Store</span>
            </div>
          </div>
        </div>
        <div class="cr-zh-preview" *ngSwitchCase="'zigzag-heading-and-cta'">
          <div class="cr-zh-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-zh-preview-content">
            <p class="cr-zh-preview-heading">{{ zigzagPreviewHeading }}</p>
            <p class="cr-zh-preview-text">{{ zigzagPreviewText }}</p>
            <span class="cr-zh-preview-cta">{{ zigzagPreviewCtaText }}</span>
          </div>
        </div>
        <div class="cr-zn-preview" *ngSwitchCase="'zigzag-no-heading-no-button'">
          <div class="cr-zn-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <p class="cr-zn-preview-text">{{ zigzagPreviewText }}</p>
        </div>
        <div class="cr-za-preview" *ngSwitchCase="'zigzag-heading-and-alt-cta'">
          <div class="cr-za-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <div class="cr-za-preview-content">
            <p class="cr-za-preview-heading">{{ zigzagPreviewHeading }}</p>
            <p class="cr-za-preview-text">{{ zigzagPreviewText }}</p>
            <span class="cr-za-preview-cta">{{ zigzagAltPreviewCtaText }}</span>
          </div>
        </div>
        <div class="cr-rv-preview" *ngSwitchCase="'reviews'">
          <p class="cr-rv-preview-name">{{ reviewsPreviewName }}</p>
          <div class="cr-rv-preview-image">
            <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
              <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
              <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
              <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
            </svg>
          </div>
          <p class="cr-rv-preview-text">{{ reviewsPreviewText }}</p>
        </div>
        <div class="cr-onp-preview" *ngSwitchCase="'x2-prop-rec-onp'">
          <div class="cr-onp-preview-card" *ngFor="let card of x2OnpPreviewCards">
            <div class="cr-onp-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <p class="cr-onp-preview-name">{{ card.name }}</p>
            <div class="cr-onp-preview-price-offer">
              <span class="cr-onp-preview-price-copy">Per day/<br/>starting from</span>
              <span class="cr-onp-preview-old-price">{{ card.oldPrice }}</span>
              <span class="cr-onp-preview-new-price">{{ card.newPrice }}</span>
            </div>
            <span class="cr-onp-preview-cta">{{ card.ctaText }}</span>
          </div>
        </div>
        <div class="cr-x2-preview" *ngSwitchCase="'x2-prop-rec'">
          <div class="cr-x2-preview-card" *ngFor="let card of x2PropRecPreviewCards">
            <div class="cr-x2-preview-image">
              <svg viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
                <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
                <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
                <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
              </svg>
            </div>
            <p class="cr-x2-preview-name">{{ card.name }}</p>
            <p class="cr-x2-preview-dest">{{ card.destination }}</p>
            <span class="cr-x2-preview-cta">{{ card.ctaText }}</span>
          </div>
        </div>
        <svg *ngSwitchDefault viewBox="0 0 100 75" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
          <rect width="100" height="75" fill="var(--cr-primary-soft)"/>
          <circle cx="28" cy="22" r="8" fill="var(--cr-blue)"/>
          <path d="M12 60 L38 28 L50 42 L68 16 L92 60 Z" fill="var(--cr-primary)"/>
        </svg>
      </div>
    </div>

    <div class="cr-block-preview-modal-footer">
      <button type="button" class="cr-btn cr-btn-primary" (click)="insertFromPreview()">Insert block</button>
    </div>
  </div>
</ng-container>
